import InteractionEvents from './InteractionEvents';

export default {
  __init__: [ 'interactionEvents' ],
  interactionEvents: [ 'type', InteractionEvents ]
};